<template>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" :data="params" :inline-message=true>
        <el-form-item label="试题篮数量设置:" label-width="130px" prop="question_num" class="limit-configure">
            <el-input size="mini"  v-model.number="form.question_num" @change="handleData"></el-input>
        </el-form-item>

        <el-form-item label="试卷日下载次数:" label-width="130px" prop="paper_download" class="limit-configure">
            <div style="width: 13%">
            <el-input size="mini" style="float: left" v-model="form.paper_download" @change="handleData"></el-input>
            <p style="color: red;margin-left: 100px">{{form.day_num}}</p>
            </div>
        </el-form-item>
        <el-form-item v-if="params.product_code==1" label="下载总次数限制:"  label-width="130px" prop="all_download" class="limit-configure">
            <div style="width: 20%">
                <!--下载总次数限制-->
                <el-input size="mini" style="float: left" v-model="form.all_download" @change="handleData"></el-input>
                <p style="color: red;margin-left: 100px">
                    {{form.current_down_num}}&nbsp;&nbsp;&nbsp;
                    <el-tooltip class="item" effect="dark" content="下载组卷试题数超过50，计算2次下载" placement="right">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </p>
            </div>
        </el-form-item>
        <el-form-item  label="(个人/日)下载限制:" label-width="130px" prop="single_down_limit" class="limit-configure">
            <el-input size="mini"  v-model="form.single_down_limit" @change="handleData"></el-input>
        </el-form-item>
        <el-form-item  label="个人日下载风控:" label-width="130px" prop="single_down_warn" class="limit-configure">
            <el-input type="number" size="mini"  v-model="form.single_down_warn" @change="handleData"></el-input> <span style="color:red;">(个人日下载试卷数超过该额度后需要输入验证码下载)</span>
        </el-form-item>
        <el-form-item label="学科每日下载限制" label-width="130px" prop="log">
            <el-button type="primary" icon="el-icon-download" size="mini" @click="dialogFormVisible=true">产品下载日志
            </el-button>
            <el-dialog title="下载日志" width="80%" :visible.sync="dialogFormVisible" @close="closeLogDialog" v-if="dialogFormVisible" >
                <zjLog :is_dialog="true" :customer_id="$route.query['id']" active_name="down_log"></zjLog>
            </el-dialog>
        </el-form-item>
        <!--<el-form-item v-if="params.product_code==1"  label="当前下载总数:" label-width="130px" prop="single_down_limit" class="limit-configure">
            &lt;!&ndash;当前下载总数&ndash;&gt;
            <span>{{form.current_down_num}}</span>
        </el-form-item>-->
        <el-table ref="multipleTable" :show-header='true' border :data="form.batch" style="width: 100%;margin-bottom: 10px;">
            <el-table-column label="所有科目">
                <template slot-scope="scope">
                    <div>{{scope.row.subject_name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="总">
                <template slot-scope="scope">
                    <el-input class="my-input-width" v-model.number="scope.row.config.all" size="mini"
                        @input="setLimit(scope.row.subject_id,'all')"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="小学">
                <template slot-scope="scope">
                    <el-input class="my-input-width" v-model.number="scope.row.config.primary" size="mini"
                              @input="setLimit(scope.row.subject_id,'primary')"></el-input>
                    <span v-if="showDownload(scope.row.subject_id)" style="color: red">{{showDownload(scope.row.subject_id)[1]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="初中">
                <template slot-scope="scope">
                    <el-input class="my-input-width" v-model.number="scope.row.config.middle" size="mini"
                              @input="setLimit(scope.row.subject_id,'middle')"></el-input>
                    <span v-if="showDownload(scope.row.subject_id)" style="color: red">{{showDownload(scope.row.subject_id)[2]}}</span>
                </template>
            </el-table-column>
            <el-table-column label="高中">
                <template slot-scope="scope">
                    <el-input class="my-input-width" v-model.number="scope.row.config.high" size="mini"
                              @input="setLimit(scope.row.subject_id,'high')"></el-input>
                    <span v-if="showDownload(scope.row.subject_id)" style="color: red">{{showDownload(scope.row.subject_id)[3]}}</span>
                </template>
            </el-table-column>
        </el-table>
    </el-form>

</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }

    .my-input-width {
        width: 100px;
    }
</style>


<script>
    import {isNumber} from 'util';
    import CommonService from "~/services/common";
    import Params from "~/config/params";
    import zjLog from "~/views/log/zj.vue";
    export default {
        components: {
            zjLog
        },
        data() {

            var check_question_num = function (rule, value, callback) {
                if (!/^(\d)*$/.test(value)) {
                    callback(new Error("试题篮必须为数字"));
                }
                callback();
            };

            var check_paper_download = function (rule, value, callback) {
                if (!/^(\d)*$/.test(value)) {
                    callback(new Error("下载次数必须为数字"));
                }
                callback();
            };

            var check_single_down_warn = function (rule, value, callback) {
                if (value < 0 || value > 100) {
                    callback(new Error("个人日下载风控必须在0到100之间"));
                }
                callback();
            };

            return {
                rules: {
                    question_num: [
                        {required: true, validator: check_question_num, trigger: 'blur'},
                    ],
                    paper_download: [
                        {required: true, validator: check_paper_download, trigger: 'blur'},
                    ],
                    single_down_warn: [
                        {required: true, validator: check_single_down_warn, trigger: 'blur'},
                    ]
                },
                form: {
                    single_down_limit:0,//个人下载限制
                    single_down_warn: 0,//个人下载风控
                    question_num: 0,
                    paper_download: 0,
                    current_down_num:0,
                    all_download:0,
                    contract_num:0,
                    day_num:0,
                    batch: [],
                },
                configUsed:false,
                formLabelWidth: '120px',
                dialogFormVisible: false,
            };
        },
        created() {
            this.$nextTick(function () {
                //不知道当初为啥这么写，先注销掉，因为这个数据是需要后台给的，而不是前端写死循环
               /* if(this.params.batch  == null) {
                    this.subjects = Params.getSubjects2();
                    var arr = [];
                    this.subjects.map((sub, k) => {
                        let obj = {};
                        if (this.params.batch == null) {
                            this.params.batch = [];
                        }
                        let filter = this.params.batch.filter(bat => {
                            return sub.subject_id == bat.subject_id;
                        })
                        obj = Object.assign(filter.length > 0 ? filter[0] : {
                            config: {
                                "all": 100,
                                "high": 100,
                                "middle": 0,
                                "primary": 0,
                            }
                        }, sub)

                        arr.push(obj);

                    })

                    this.params.batch = arr;
                }*/

                this.form = Object.assign({},this.params);

                this.getConfigUsed();
            })
        },
        props: {
            params: {
                type: Object,
                required: true
            }
        },
        methods: {
            /**
             * 验证表单
             */
            validateForm() {
                let flag = false;
                this.$refs["form"].validate(valid => {
                    flag = valid;
                });
                return flag;
            },
            handleData() {
                this.$emit("handleData", this.form);
            },
            /**@description 所有科目设置 */
            setLimit(val,type) {
                this.handleData();
                if (val != 0) {
                    return false;
                }
                let all = this.form.batch.filter(item => {
                    return item.subject_id == val;
                });
                this.form.batch.forEach(item => {
                    item.config[type] = all[0].config[type];
                })
            },
            showDownload(subject_id){
                if(!subject_id) return false;
                if(!this.configUsed) return false;
                if(!this.configUsed[subject_id]) return false;
                return this.configUsed[subject_id];
            },
            getConfigUsed(){
                CommonService.getConfigUse({customer_id:this.$route.query['id'],product_code:this.params.product_code}).then(res=>{
                        this.configUsed = res.data;
                });
            },


            closeLogDialog(){
                this.dialogFormVisible = false;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/zujuan/limitConfigure.vue